<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <!--div class="card" v-if="$gate.isAdmin()"-->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">User List</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Kantor</th>
                      <th>Status?</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="user in users.data" :key="user.id">

                      <td>{{user.id}}</td>
                      <td class="text-capitalize">{{user.name}}</td>
                      <td>{{user.email}}</td>
                      <td class="text-capitalize">{{user.roles.name}}</td>
                      <td class="text-capitalize">{{user.kantor.value}}</td>
                      <td>
                        <template v-if="user.is_active == '1'">
                            <a href='#'><i class='fa fa-check green'></i></a> 
                        </template>
                        <template v-else>
                           <a href='#'><i class='fa fa-times red'></i></a>
                        </template>
                          
                          
                        
                      </td>
                      <td>

                        <a href="#" @click="editModal(user)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        <a href="#" @click="deleteUser(user.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="users" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New User</h5>
                    <h5 class="modal-title" v-show="editmode">Update User's Info</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateUser() : createUser()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" required>
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="form.email" type="text" name="email"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }" required>
                            <has-error :form="form" field="email"></has-error>
                        </div>
                    
                        <div class="form-group">
                            <label>Password</label>
                            <input v-model="form.password" type="password" name="password"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" autocomplete="false">
                            <has-error :form="form" field="password"></has-error>
                            <small v-show="editmode">Input Jika Ingin Merubah Password Pengguna</small>
                        </div>
                        <div class="form-group">
                            <label>Roles</label>
                            <select name="roles_id" v-model="form.roles_id" id="roles_id" class="form-control" :class="{ 'is-invalid': form.errors.has('roles_id') }" required>
                                <option value="" selected disabled>-- PILIH ROLE USER --</option>
                                <option 
                                  v-for="row in roles_list" :key="row.id"
                                  :value="row.id"
                                  :selected="row.id == form.roles_id">{{ row.name }}</option>
                            </select>
                            <has-error :form="form" field="roles_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Kantor</label>
                            <select name="kantor_id" v-model="form.kantor_id" id="kantor_id" class="form-control" :class="{ 'is-invalid': form.errors.has('kantor_id') }" required>
                                <option value="" selected disabled>-- PILIH KANTOR USER --</option>
                                <option 
                                  v-for="row in kantor_list" :key="row.id"
                                  :value="row.id"
                                  :selected="row.id == form.kantor_id">{{ row.value }}</option>
                            </select>
                            <has-error :form="form" field="kantor_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Status</label>
                            <select name="is_active" v-model="form.is_active" id="is_active" class="form-control" :class="{ 'is-invalid': form.errors.has('is_active') }" required>
                                <option value="" selected disabled>-- PILIH STATUS USER --</option>
                                <option value="1" :selected="form.is_active == 1">Aktif</option>
                                <option value="0" :selected="form.is_active != 1">Tidak Aktif</option>
                            </select>
                            <has-error :form="form" field="is_active"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Tipe Data Tampilan</label>
                            <select name="data_tipe" v-model="form.data_tipe" id="data_tipe" class="form-control" :class="{ 'is-invalid': form.errors.has('data_tipe') }">
                                <option value="" selected>NONE</option>
                                <option value="1" :selected="form.data_tipe == '1'">PPPOE</option>
                                <option value="2" :selected="form.data_tipe == '2'">Corporate</option>
                                <option value="99" :selected="form.data_tipe == '99'">SEMUA</option>
                            </select>
                            <has-error :form="form" field="data_tipe"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                users : {},
                form: new Form({
                    id : '',
                    name: '',
                    email: '',
                    password: '',
                    roles_id: '',
                    kantor_id: '',
                    is_active: '',
                    data_tipe: '',
                }),
                kantor_list: [],
                roles_list: [],
            }
        },
        methods: {

            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('api/user?page=' + page).then(({ data }) => (this.users = data.data));

                  this.$Progress.finish();
            },
            updateUser(){
                this.$Progress.start();
                // console.log('Editing data');
                this.form.put('api/user/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadUsers();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(user){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(user);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },
            
            deleteUser(id){
                Swal.fire(
                    'WARNING!',
                    'MOHON NONAKTIFKAN PENGGUNA DI MENU EDIT.<br><br> UNTUK MENGHAPUS PENGGUNA, HUBUNGI ADMIN',
                    'warning'
                );
                /*
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {

                        // Send request to the server
                         if (result.value) {
                                this.form.delete('api/user/'+id).then(()=>{
                                        Swal.fire(
                                        'Deleted!',
                                        'Your file has been deleted.',
                                        'success'
                                        );
                                    // Fire.$emit('AfterCreate');
                                    this.loadUsers();
                                }).catch((data)=> {
                                  Swal.fire("Failed!", data.message, "warning");
                              });
                         }
                    })
                    */
            },
          loadUsers(){
            if(this.$gate.isAdmin()){
              axios.get("api/user").then(({ data }) => (this.users = data.data));
            }
          },
          loadRoles(){
            axios.get("api/user/roles_list").then(({ data }) => (this.roles_list = data.data));
          },
          loadKantor(){
            axios.get("api/user/kantor_list").then(({ data }) => (this.kantor_list = data.data));
          },
          createUser(){

              this.form.post('api/user')
              .then((response)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: response.data.message
                  });

                  this.$Progress.finish();
                  this.loadUsers();

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          }

        },
        mounted() {
            console.log('User Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadUsers();
            this.loadRoles();
            this.loadKantor();
            this.$Progress.finish();
        }
    }
</script>